

(function () {
  var discountQuantities = [];
  
  window.addEventListener('DOMContentLoaded', (event) => {

    if(window.hulkapps.product != {} && window.hulkapps.product != null) {

      checkElement('.hulkapps-volume-discount-tiers')
      .then((el) => {
        
        // window.gim is gevuld vanuit product-info

        if(!window.gim || !window.gim.prices)
          return;

        var originalM2Price = window.gim.prices.unit_price;
        var originalPrice = window.gim.prices.product_full_price;
        
        var headerRow = el.querySelector('thead tr');
        
        if(originalM2Price != null) {
          var m2DiscountHeaderCell = document.createElement('th');
          m2DiscountHeaderCell.innerHTML = 'Prijs per m<sup>2</sup>';
          headerRow.appendChild(m2DiscountHeaderCell);
          
          var m2ExVatDiscountHeaderCell = document.createElement('th');
          m2ExVatDiscountHeaderCell.innerHTML = 'Prijs/m<sup>2</sup> ex btw';
          headerRow.appendChild(m2ExVatDiscountHeaderCell);
        }
        
        var discountHeaderCell = document.createElement('th');
        var discountHeaderTextNode = document.createTextNode('Prijs');
        discountHeaderCell.appendChild(discountHeaderTextNode);
        headerRow.appendChild(discountHeaderCell);
        
        // get all rows with the discount values. 
        var discountRows = el.querySelectorAll('tbody tr');
       
        for(var i = 0; i < discountRows.length; i++) {
          var row = discountRows[i];
          var minQty = row.cells[0].textContent.match(/\d+/g).map(Number)[0];
          var discountPerc = row.cells[1].textContent.match(/\d+/g).map(Number)[0];
          
          var discount = {
            minQty: minQty,
            discountPerc: discountPerc
          };
          discountQuantities.push(discount);

          // add discounted m2 price in table
          if(originalM2Price != null) {
            var m2DiscountPriceCell = row.insertCell(-1);
            var m2DiscountPriceTextNode = document.createTextNode(calculateDiscountAndFormat(discountPerc, originalM2Price, true));
            m2DiscountPriceCell.appendChild(m2DiscountPriceTextNode);
          
            // add discount m2 price excluding VAT in table
            var discountM2PriceExVatCell = row.insertCell(-1);
            var discountM2PriceExVatTextNode = document.createTextNode(calculateDiscountAndFormat(discountPerc, originalM2Price, false));
            discountM2PriceExVatCell.appendChild(discountM2PriceExVatTextNode);
          }
          // add discount price in table
          var discountPriceCell = row.insertCell(-1);
          var discountPriceTextNode = document.createTextNode(calculateDiscountAndFormat(discountPerc, originalPrice, true));
          discountPriceCell.appendChild(discountPriceTextNode);
        }
        
        var volumeDiscountCard = document.querySelector('.volume-discount-card').style.display = 'block';
        
        listenToQuantity();
        
        // m2 calculator qty
        var m2QtyEl = document.querySelector('[name=required_sku]');
          if(m2QtyEl != null) {
            m2QtyEl.addEventListener('change', function(el) {
              setTimeout(checkDiscount, 100);
          });
        }
        
        var m2calc_reqm2 = document.querySelector('[name=m2input]');
        if(m2calc_reqm2 != null) {
          m2calc_reqm2.addEventListener('keyup', function(el) {
              setTimeout(checkDiscount, 100);
          });
        }
      });
    }
  });
  
  var isRebind = false;
  
  function listenToQuantity() {
    document.querySelector('[name=quantity]').addEventListener('change', function(el) {      
      setTimeout(checkDiscount, 100);
    });
    document.querySelector('[name=quantity]').addEventListener('keyup', function(el) {      
      setTimeout(checkDiscount, 100);
    });
  }


  
  // get the quantity and find out if a discount is applicable. 
  function checkDiscount() {
    if(discountQuantities.length <= 0) 
      return;
    
    var qty = document.querySelector('[name=quantity]').value;
    var discountPerc = 0;
    
    // reverse loop through discount table
    for(i = discountQuantities.length - 1; i >= -1; i--) {
      var discountRow = discountQuantities[i];

      if(discountRow == null) {
        // no discount
        break;
      }
      
      if(qty >= discountRow.minQty) {
        // apply this discount
        discountPerc = discountRow.discountPerc;
	    break;
      }
    }
    
    //console.log('korting %', discountPerc);
    applyDiscount(discountPerc);
  }
  
  function applyDiscount(discountPerc) {
    var discountPriceEl = document.querySelector('.volume-discount-price'); 
    var m2El = document.querySelector('.original-price .part-price');
    var m2ExVatEl = document.querySelector('.original-price .part-price-exvat');
    
    var priceEl = document.querySelector('.unit-price.product-price');
    var unitPriceExVatEl = document.querySelector('.original-price .unit-price-exvat');
    
    if(!window.gim || !window.gim.prices)
      return;

    // maak de volume-discount-price leeg
    while (discountPriceEl.firstChild) {
      discountPriceEl.removeChild(discountPriceEl.firstChild);
    }
    
    if(discountPerc <= 0) {
      if(m2El != null) {
        m2El.classList.remove('price--compare', 'price--highlight');
      }
    
      if(m2ExVatEl != null) {
        m2ExVatEl.classList.remove('price--compare');
      }
      
      priceEl.classList.remove('price--compare', 'price--highlight');
      
      if(unitPriceExVatEl != null) {
      	unitPriceExVatEl.classList.remove('price--compare');
      }
      
      return;
    }
    
    if(m2El != null) {
      // product has m2 price 
      var m2Price = window.gim.prices.unit_price;
     
      var dupM2El = m2El.cloneNode(true);
      dupM2El.classList.remove('original-price', 'price--compare', 'price--highlight');
      dupM2El.querySelector('span').innerText = calculateDiscountAndFormat(discountPerc, m2Price, true);
      dupM2El.classList.add('price--highlight');
      discountPriceEl.appendChild(dupM2El);

      m2El.classList.add('price--compare');
    }

    if(m2ExVatEl != null) {
      var m2ExPrice =  window.gim.prices.unit_price / 1.21;
      
      var dupExPriceEl = m2ExVatEl.cloneNode(true);
      dupExPriceEl.querySelector('span').innerText = calculateDiscountAndFormat(discountPerc, m2ExPrice, true);
      dupExPriceEl.classList.remove('price--compare');
      
      var discountM2Node = document.querySelector('div.volume-discount-price .part-price.price--highlight');
      discountM2Node.parentNode.insertBefore(dupExPriceEl, discountM2Node.nextSibling);
      
      m2ExVatEl.classList.add('price--compare');
    }
    
    var price = window.gim.prices.product_full_price;
    var dupPriceEl = priceEl.cloneNode(true);
    dupPriceEl.classList.remove('original-price', 'price--compare', 'price--highlight');
    dupPriceEl.querySelector('span').innerText = calculateDiscountAndFormat(discountPerc, price, true);
    dupPriceEl.classList.add('price--highlight')
    
    discountPriceEl.appendChild(dupPriceEl);
    priceEl.classList.add('price--compare');
    
    if(unitPriceExVatEl != null) {
      var unitPriceExVat = window.gim.prices.unit_price / 1.21;
      var dupUnitPriceExVatEl = unitPriceExVatEl.cloneNode(true);

      dupUnitPriceExVatEl.querySelector('span').innerText = calculateDiscountAndFormat(discountPerc, unitPriceExVat, true);
      dupUnitPriceExVatEl.classList.remove('price--highlight');
      
      var unitPriceEl = document.querySelector('.unit-price.price--highlight');
      
      unitPriceEl.appendChild(dupUnitPriceExVatEl);
      
      unitPriceExVatEl.classList.add('price--compare');
    }

    var elCompares = document.querySelectorAll('div.volume-discount-price .price--compare');
    elCompares.forEach((e) => e.classList.remove('price--compare'))
    
  }
  
  function calculateDiscountAndFormat(discountPerc, price, inclVat) {
    var discount = ((100 - discountPerc) / 100);
    var vatDivider = inclVat ? 1 : 1.21;
    
    var discountPrice = ((price / vatDivider) * discount).toFixed(2);
    var formattedDiscount = '€' + discountPrice.replace('.', ',');
    return formattedDiscount
  }
  
  function rafAsync() {
    return new Promise(resolve => {
        requestAnimationFrame(resolve);
    });
  }

  function checkElement(selector) {
    var el = document.querySelector(selector);
    if (el === null) {
      if(window.hulkapps.is_volume_discount == false) {
        return Promise.reject(new Error('no volume discount for this product'));
      }

      return rafAsync().then(() => checkElement(selector));
    } else {
      return Promise.resolve(el);
    }
  }
  
}());
